<template>
	<div class="scrollable only-y">		
		<div class="page-header card-base card-shadow--medium">
			<h2 class="no-m white-text"><i class="mdi mdi-bell widget-icon accent-text fs-30"></i> {{ $t('menu.notification') }}</h2>
		</div>
		<el-dialog title="New Notification" :visible.sync="dialogFormVisible">
			<el-form ref="form" :model="notifications" label-width="120px">
				<el-form-item label="Title" :label-width="formLabelWidth">
					<el-input v-model="notifications.title"></el-input>
				</el-form-item>

				<el-form-item label="Message" :label-width="formLabelWidth">
					<el-input rows="6" type="textarea" v-model="notifications.message"></el-input>
				</el-form-item>

				<el-form-item label="Message Type" :label-width="formLabelWidth">
					<template>
						<el-select v-model="notifications.messageType" placeholder="Select">
							<el-option
							v-for="item in options"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
					</template>
				</el-form-item>
				
				<el-form-item label="Recipient" :label-width="formLabelWidth">
					<template>
						<el-select v-model="notifications.recipientType" placeholder="Select" @change="changeRecipient(notifications.recipient)">
							<el-option
							v-for="item in recipientOptions"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
					</template>

				</el-form-item><el-form-item v-if="specificRecipient" label="Customer" :label-width="formLabelWidth">
					<template>
						<el-select filterable v-model="notifications.recipient" placeholder="Select Customer">
							<el-option
							v-for="(item, key) in customer"
							:key="key"
							:label="item.customer_name"
							:value="item.customer_id">
							</el-option>
						</el-select>
					</template>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" @click="addNotification" :loading="loadingBtn">Create</el-button>
    				<el-button @click="dialogFormVisible=false">Cancel</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="Show Notification" :visible.sync="dialogShowFormVisible">
			
			<el-form ref="form" :model="detailsNotifications" label-width="120px">
				<el-form-item label="Title" :label-width="formLabelWidth">
					<el-input v-model="detailsNotifications.title" :disabled="disabled == 0"></el-input>
				</el-form-item>

				<el-form-item label="Message" :label-width="formLabelWidth">
					<el-input rows="6" type="textarea" v-model="detailsNotifications.message" :disabled="disabled == 0"></el-input>
				</el-form-item>

				<el-form-item label="Message Type" :label-width="formLabelWidth" >
					<template>
						<el-select v-model="detailsNotifications.message_type" placeholder="Select" :disabled="disabled == 0">
							<el-option
							v-for="item in options"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
					</template>
				</el-form-item>
				
				<el-form-item label="Recipient" :label-width="formLabelWidth">
					<template>
						<el-select v-model="detailsNotifications.recipient_type" placeholder="Select" @change="changeDetailRecipient()" :disabled="disabled == 0">
							<el-option
							v-for="item in recipientOptions"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
					</template>
				</el-form-item>
				<el-form-item v-if="detailSpecificRecipient" label="Customer" :label-width="formLabelWidth">
					<template>
						<el-select filterable v-model="detailsNotifications.recipient" placeholder="Select Customer" :disabled="disabled == 0">
							<el-option
							v-for="(item, key) in customer"
							:key="key"
							:label="item.customer_name"
							:value="item.customer_id">
							</el-option>
						</el-select>
					</template>
				</el-form-item>
				<el-form-item>
					<el-button v-if="disabled==0" @click="disabled = (disabled + 1) % 2">Edit</el-button>
                    <el-button v-else-if="disabled==1" @click="disabled = (disabled + 1) % 2">Cancel</el-button>
                    <el-button v-if="disabled==1" @click="updatedNotification()" type="primary" :loading="loadingBtn">Save</el-button>
    				<el-button  style="float:right" @click="dialogShowFormVisible=false;disabled = (disabled + 1) % 2">Close</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="List mail recipient" :visible.sync="dialogListRecipient">
			{{ subscriber.map(v => v.email).toString() }}
		</el-dialog>
		<el-dialog title="New Mail Setting" :visible.sync="dialogFormVisibleMail">
			<el-form ref="form" :model="subscriberForm" label-width="120px">
				<el-form-item label="From" :label-width="formLabelWidth">
					<el-input disabled v-model="subscriberForm.from"></el-input>
				</el-form-item>

				<el-form-item label="Recipient" :label-width="formLabelWidth">
					<el-input disabled v-model="total_subscriber"></el-input>
				</el-form-item>

				<div style="text-align: right; margin-bottom: 20px">
					<el-button type="text" @click="showAllRecipient">Show List Recipient</el-button>
				</div>
				
				<!-- <el-form-item label="Recipient" :label-width="formLabelWidth">
					<el-input disabled v-model="total_subscriber"></el-input>
				</el-form-item> -->
				
				<!-- <el-form-item label="To" :label-width="formLabelWidth">
					<template>
						<el-select multiple filterable allow-create v-model="subscriberForm.to" placeholder="Select">
							<el-option
							v-for="item in subscriber"
							:key="item.id"
							:label="item.email"
							:value="item.email">
							</el-option>
						</el-select>
					</template>
				</el-form-item> -->

				<el-form-item label="Message" :label-width="formLabelWidth">
					<el-input rows="6" type="textarea" v-model="subscriberForm.message"></el-input>
				</el-form-item>

				<el-form-item label="Reply To" :label-width="formLabelWidth">
					<el-input disabled v-model="subscriberForm.reply_to"></el-input>
				</el-form-item>

				<el-form-item style="text-align: right;">
					<el-button type="primary" @click="sendToAll(subscriber.map(v => v.email))" :loading="loadingBtnSendMail">Sent to All ({{total_subscriber}})</el-button>
					<!-- <el-button type="primary" @click="sendMail(subscriberForm.to)" :loading="loadingBtnSendMail">Sent</el-button> -->
    				<el-button @click="dialogFormVisibleMail=false">Cancel</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<el-card>
			<el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
				<el-tab-pane label="Notification" name="first">
					<el-card class="pb-20">
						<div slot="header" class="clearfix mb-10">
							<el-col :span="24" :md="24" :sm="24" :xs="24" justify="end" >
								<el-card style="background: linear-gradient(45deg, rgb(36, 147, 147) 0%, rgba(85,85,85,1) 100%); color:#ffffff; font-weight:bold;" class="mb-10">
									Total Notification Message : <br>
									<span style="font-size:32px;">{{ (total) }}</span>
								</el-card>
							</el-col>
							<el-button type="primary" @click="dialogFormVisible = true" style="float:left;" class="mt-20 mb-20">+ Add Notification</el-button>
							<el-col :span="24" :md="24" :sm="24" :xs="24" justify="end" >
								<el-pagination
									background
									prev-text="Prev"
									next-text="Next"
									layout="prev, pager, next"
									:page-size="10"
									@current-change="paginateNotification"
									:current-page="currentPage"
									:total="parseInt(total)">
								</el-pagination>
							</el-col>
						</div>
						<template>
							<el-table :data="notification" style="width: 100%" v-loading="loadingNotification" element-loading-text="Loading..." element-loading-spinner="el-icon-loading">
								<el-table-column prop="date" label="Date" width="200">
									<template slot-scope="props">
										<p style="font-weight:bold;">{{ formatDate(props.row.created_at, "DD/MM/YY HH:mm:ss") }}</p>
									</template>
								</el-table-column>
								
								<el-table-column prop="recipient" label="Recipient" width="250">
									<template slot-scope="props">
										<p style="font-weight:bold;" v-if="props.row.recipient== null">All</p>
										<p style="font-weight:bold;" v-else>{{ props.row.cust_name }}</p>
									</template>
								</el-table-column>
			
								<el-table-column prop="message_type" label="Message Type" width="150">
									<template slot-scope="props">
										<p style="font-weight:bold;">{{ capitalizeFirstLetter(props.row.message_type) }}</p>
									</template>
								</el-table-column>
			
								<el-table-column prop="title" label="Title" width="350">
									<template slot-scope="props">
										<p style="font-weight:bold;">{{ props.row.title }}</p>
									</template>
								</el-table-column>
								
								<el-table-column prop="message" label="Message" width="450">
									<template slot-scope="props">
										<el-tooltip>
											<div class="tooltip" slot="content">{{ props.row.message }}</div>
											<p style="font-weight:bold;">{{ props.row.message.substring(0, 50) }} {{props.row.message.length > 50 ? '...' : ''}}</p>
										</el-tooltip>
									</template>
								</el-table-column>
			
								<el-table-column fixed="right" label="#" width="250">
									<template slot-scope="scope">
										<el-button @click="detailNotification(scope.row.id)" type="primary" size="small">
											<i class="mdi mdi-eye"></i>
										</el-button>
										<el-button @click="deleteNotification(scope.row.id)" type="danger" size="small" :loading="loadingBtnDelete">
											<i class="mdi mdi-delete-forever"></i>
										</el-button>
									 </template>
								</el-table-column>
							</el-table>
						
						</template>
						<el-col :span="24" :md="24" :sm="24" :xs="24" justify="end" class="mt-20">
							<el-pagination
								background
								prev-text="Prev"
								next-text="Next"
								layout="prev, pager, next"
								:page-size="10"
								@current-change="paginateNotification"
								:current-page="currentPage"
								:total="parseInt(total)">
							</el-pagination>
						</el-col>
					</el-card>
				</el-tab-pane>
				<el-tab-pane label="Subscriber" name="two">
					<el-card class="pb-20">
						<div slot="header" class="clearfix mb-10">
							<el-col :span="24" :md="24" :sm="24" :xs="24" justify="end" >
								<el-card style="background: linear-gradient(45deg, rgb(36, 147, 147) 0%, rgba(85,85,85,1) 100%); color:#ffffff; font-weight:bold;" class="mb-10">
									Total Subscriber : <br>
									<span style="font-size:32px;">{{ (total_subscriber) }}</span>
								</el-card>
							</el-col>
							<el-button type="primary" @click="dialogFormVisibleMail = true" style="float:left;" class="mt-20 mb-20">+ Create Mail</el-button>
							<el-col :span="24" :md="24" :sm="24" :xs="24" justify="end" >
								<el-pagination
									background
									prev-text="Prev"
									next-text="Next"
									layout="prev, pager, next"
									:page-size="10"
									@current-change="paginateSubscriber"
									:current-page="currentPage"
									:total="parseInt(total_subscriber)">
								</el-pagination>
							</el-col>
						</div>
						<template>
							<el-table :data="subscriber" style="width: 100%" v-loading="loadingNotification" element-loading-text="Loading..." element-loading-spinner="el-icon-loading">
								<el-table-column prop="date" label="Date" width="200">
									<template slot-scope="props">
										<p style="font-weight:bold;">{{ formatDate(props.row.created_at, "DD/MM/YY HH:mm:ss") }}</p>
									</template>
								</el-table-column>
			
								<el-table-column prop="email" label="Email" width="350">
									<template slot-scope="props">
										<p style="font-weight:bold;">{{ props.row.email }}</p>
									</template>
								</el-table-column>
								
								<el-table-column fixed="right" label="#" width="250">
									<template slot-scope="scope">
										<el-button :loading="loadingSendMail" @click="sendMail(scope.row.email)" type="primary" size="small">
											<i class="mdi mdi-email"></i>
										</el-button>
										<!-- <el-button @click="deleteNotification(scope.row.id)" type="danger" size="small" :loading="loadingBtnDelete">
											<i class="mdi mdi-delete-forever"></i>
										</el-button> -->
									 </template>
								</el-table-column>
							</el-table>
						
						</template>
						<el-col :span="24" :md="24" :sm="24" :xs="24" justify="end" class="mt-20">
							<el-pagination
								background
								prev-text="Prev"
								next-text="Next"
								layout="prev, pager, next"
								:page-size="10"
								@current-change="paginateNotification"
								:current-page="currentPage"
								:total="parseInt(total_subscriber)">
							</el-pagination>
						</el-col>
					</el-card>
				</el-tab-pane>
			</el-tabs>
		</el-card>
		<el-card class="mt-20 mb-20 card-base" style="border:none; color:white;">
			DAM Corp.
		</el-card>
	</div>
</template>

<script>
import api from '@/networkClient'
import config from '@/config'
const moment = require('moment')
import emailjs from 'emailjs-com';

export default {
	name: 'Notification',
	data () {
		return {
			activeName: "first",
			options: [{
				value: 'alert',
				label: 'Alert'
			}, {
				value: 'warning',
				label: 'Warning'
			}, {
				value: 'information',
				label: 'Information'
			}],
			recipientOptions: [{
				value: 'all',
				label: 'All'
			}, {
				value: 'specific',
				label: 'Specified User'
			}],
			disabled: 0,
			value: '',
			dialogFormVisible: false,
			dialogFormVisibleMail: false,
			dialogShowFormVisible: false,
			dialogListRecipient: false,
			notification: [],
			subscriber: [],
			notifications: {
				title: "",
				message: "",
				messageType: "",
				origin: "dash",
				recipientType: "",
				recipient: "",
				status: "sent",
				createdAt: "",
				updatedAt: ""
			},
			subscriberForm: {
				from: "damcorp",
				to: [],
				message: "",
				reply_to: "developer@damcorp.id"
			},
			detailsNotifications: {
				id: "",
				title: "",
				message: "",
				message_type: "",
				origin: "dash",
				recipient_type: "",
				recipient: "",
				status: "sent",
				createdAt: "",
				updatedAt: ""
			},
			total:'',
			total_subscriber:0,
			customer:[],
			recipient:'',
			currentPage: 1,
			specificRecipient:false,
			detailSpecificRecipient:false,
			loadingNotification:true,
			formLabelWidth: '200px',
			loadingBtn:false,
			loadingBtnDelete:false,
			loadingSubscriber: false,
			loadingSendMail: false,
			loadingBtnSendMail: false
		}
	},
	methods: {
		showAllRecipient(){
			console.log('recipient list')
			this.dialogListRecipient = true
		},
		async handleClick(targetName){
            if(targetName.name=='first'){
				await this.Notification()
            } else {
				this.Subscriber()
            }
		},
		sendToAll(row, e){
			console.log('list recipient',row)
			console.log('target a',e)
			this.$confirm('Send email to '+this.total_subscriber+' recipient. Continue?', 'Info', {
				confirmButtonText: 'OK',
				cancelButtonText: 'Cancel',
				type: 'info'
			}).then(() => {
				try {
					this.loadingBtnSendMail = true
					var templateParams = {
						name: 'Damcorp',
						notes: 'Check this out!'
					};
					
					emailjs.send('service_q62mrq5', 'template_37ukrof', templateParams, 'Xp8D5lzNkbt6VzSFf')
					.then(function(response) {
					console.log('SUCCESS!', response.status, response.text);
					this.$message({
						type: 'success',
						message: 'Send mail success'
					});
					}, function(error) {
					console.log('FAILED...', error);
					});
				} catch (error){
					console.log({error})
				}
				this.loadingBtnSendMail = false
			}).catch(() => {
				this.$message({
					type: 'info',
					message: 'Operation canceled'
				});          
				this.loadingBtnSendMail = false
			});
		},
		sendMail(row, e){
			console.log('target a',e)
			this.$confirm('Send email to '+row+'. Continue?', 'Info', {
				confirmButtonText: 'OK',
				cancelButtonText: 'Cancel',
				type: 'info'
			}).then(() => {
				try {
					this.loadingBtnSendMail = true
					var templateParams = {
						name: 'Damcorp',
						notes: 'Check this out!'
					};
					
					emailjs.send('service_q62mrq5', 'template_37ukrof', templateParams, 'Xp8D5lzNkbt6VzSFf')
					.then(function(response) {
					console.log('SUCCESS!', response.status, response.text);
					this.$message({
						type: 'success',
						message: 'Send mail success'
					});
					}, function(error) {
					console.log('FAILED...', error);
					});
				} catch (error){
					console.log({error})
				}
				this.loadingBtnSendMail = false
			}).catch(() => {
				this.$message({
					type: 'info',
					message: 'Operation canceled'
				});          
				this.loadingBtnSendMail = false
			});
		},
		capitalizeFirstLetter(string) {
			if(string == null || string == ""){
				return "-"
			} else {
				return string.charAt(0).toUpperCase() + string.substring(1);
			}
		},
		formatDate(val, format){
            return moment(val).format(format)
		},
		changeRecipient(recipient){
			this.notifications.recipientType == 'specific' ? this.specificRecipient = true : this.specificRecipient = false
		},
		changeDetailRecipient(){
			this.detailsNotifications.recipient_type == 'specific' ? this.detailSpecificRecipient = true : this.detailSpecificRecipient = false
		},
		async Notification(page = 1){
			
			this.loadingNotification = true
            await api({
                url: config.baseApi + "notification?page="+page,
                method: 'get'
            })
            .then(res => {
				if(res.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				}
				else {
					this.notification = res.data.data.notification
					this.total = res.data.data.total
				}
            })
            .catch(err => {

            })
            this.loadingNotification = false
		},
		async Subscriber(page = 1){
			
			this.loadingSubscriber = true
            await api({
                url: config.baseApi + "list-subscribe?page="+page,
                method: 'get'
            })
            .then(res => {
				if(res.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				}
				else {
					this.subscriber = res.data.data
					// this.subscriberForm.to = res.data.data
					this.total_subscriber = res.data.data.length
				}
            })
            .catch(err => {

            })
            this.loadingSubscriber = false
		},
		async getCustomer(){
			this.loadingNotification = true
            await api({
                url: config.baseApi + "notification/consumen",
                method: 'get'
            })
            .then(res => {
				if(res.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				}
				else {
					this.customer = res.data.data.consumen
				}
            })
            .catch(err => {

            })
            this.loadingNotification = false
		},
		async addNotification(){
			this.loadingBtn = true
			var [] = this.notifications
			await api({
				url: config.baseApi + "notification",
				method: 'post',
				data: {
					"title": this.notifications.title,
					"message": this.notifications.message,
					"messageType": this.notifications.messageType.toLowerCase(),
					"origin": this.notifications.origin,
					"recipientType": this.notifications.recipientType,
					"recipient": this.notifications.recipient,
					"status": this.notifications.status,
					"createdAt": this.notifications.createdAt,
					"updatedAt": this.notifications.updatedAt,
				}
			}).then(res => {
				if(res.data.ec != 200){
						this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					this.$message({
						type: 'success',
						message: 'Add Notication Success'
					});
					this.clear()
					// this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
					this.dialogFormVisible = false
					this.Notification()
				}
			}).catch(err => {
				console.log("Error",err)
			})
			this.loadingBtn = false
		},

		async paginateNotification(page){
			this.currentPage = page
			await this.Notification(this.currentPage)
		},

		async paginateSubscriber(page){
			this.currentPage = page
			await this.Subscriber(this.currentPage)
		},

		async detailNotification(notificationId){
			this.dialogShowFormVisible = true
			await api ({
				url: config.baseApi + "notification/" + notificationId,
				method: 'get'
			})
			.then(res => {
				this.detailsNotifications = res.data.data
			
				res.data.data.recipient_type == 'specific' ? this.detailSpecificRecipient = true : this.detailSpecificRecipient = false

			})
			.catch(err => {
				console.log("Error",err)
			})
		},

		async updatedNotification(){
            this.loadingBtn = true
			let notificationId = this.detailsNotifications.id
			await api({
				url: config.baseApi + 'notification/' + notificationId,
				method: 'patch',
				data: {
					"title": this.detailsNotifications.title,
					"message": this.detailsNotifications.message,
					"message_type": this.detailsNotifications.message_type,
					"origin": this.detailsNotifications.origin,
					"recipient_type": this.detailsNotifications.recipient_type,
					"recipient": this.detailsNotifications.recipient,
					"status": this.detailsNotifications.status
				}
			}).then(res => {
				if(res.data.ec != 200){
                    // console.log('Update sukses')
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
					// console.log('fatal error')
					this.dialogShowFormVisible = false
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success")
					// console.log("res",res.data)
					this.dialogShowFormVisible = false
					this.Notification()
				}
			}).catch(err => {
				// console.log("Error",err)
            })
            this.loadingBtn=false
		},
		
		async deleteNotification(notificationId){
			this.loadingNotification = true
			this.loadingBtnDelete = true
			this.$confirm('This will permanently delete the notification. Continue?', 'Warning', {
			confirmButtonText: 'OK',
			cancelButtonText: 'Cancel',
			type: 'warning',
			center: true
			}).then(() => {
				this.loadingBtnDelete = true
				api({
					url: config.baseApi + 'notification/delete/' + notificationId,
					method: 'get',
					params:{
						notificationId: notificationId
					}
				}).then(res => {
					if(res.data.ec != 200){
						this.$swal(this.$t('error'), this.$t('error_text'), "error")
					} else {
						// 
						this.$message({
							type: 'success',
							message: 'Delete completed'
						});
						this.clear()
						this.Notification()
					}
				}).catch(err => {
					console.log("Error",err)
				})
				this.loadingBtnDelete = false
			}).catch(() => {
				this.$message({
					type: 'info',
					message: 'Delete canceled'
				});
			});
			
			this.loadingBtnDelete = false
			this.loadingNotification = false
		},

		clear(){
			this.notifications.title = ''
			this.notifications.message = ''
			this.notifications.messageType = ''
			this.notifications.recipientType = ''
			this.notifications.recipient = ''
			this.specificRecipient = false
			
		}
	},
	async mounted(){
		await this.Notification()
		await this.Subscriber()
		await this.getCustomer()
		
	}
}
</script>
<style>

.swal2-container {
  	z-index: 10000;
}
</style>

<style lang="scss" scoped>

.tooltip {
	width: 300px;
	
}

.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}
</style>